import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  useToast,
} from '@chakra-ui/react';
import React, { useRef, useState } from 'react';
import { FirebaseCourseWithUid } from '../../../types/types';
import { deleteCourse } from '../../../utils/deleteCourse';

interface AdminCourseDeleteAlertProps {
  isOpen: boolean;
  onClose: () => void;
  firebaseCourse: FirebaseCourseWithUid;
}

export const AdminCourseDeleteAlert = ({
  isOpen,
  onClose,
  firebaseCourse,
}: AdminCourseDeleteAlertProps) => {
  const cancelRef = useRef(null);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const toast = useToast();

  const deleteHandler = async () => {
    setIsDeleteLoading(true);
    try {
      await deleteCourse(firebaseCourse);
      setIsDeleteLoading(false);
      onClose();
      toast({
        title: 'Kurs gelöscht',
        status: 'success',
        duration: 9000,
        isClosable: true,
      });
    } catch (e) {
      toast({
        title: 'Ein Fehler ist aufgetreten.',
        description: 'Bitte versuche es später noch einmal.',
        status: 'error',
        duration: 9000,
        isClosable: true,
      });
      setIsDeleteLoading(false);
    }
  };

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Kurs löschen
          </AlertDialogHeader>

          <AlertDialogBody>
            Bist du sicher, dass dieser Kurs gelöscht werden soll?
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={onClose}>
              Abbrechen
            </Button>
            <Button
              isLoading={isDeleteLoading}
              onClick={deleteHandler}
              colorScheme="red"
              ml={3}
            >
              Löschen
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};
